import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {RoutingService, UrlFormatted} from '@core/services/routing.service';

import {RouterModule} from '@angular/router';
import {NgOptimizedImage, NgStyle} from '@angular/common';
import {RouterContextDirective} from '@core/directives/router-context.directive';

export interface SpotObj {
  __typename?: 'FrontPageSpot';
  backgroundImage?: string;
  columnsLg?: string;
  columnsMd?: string;
  columnsSm?: string;
  ctaDesign?: string;
  ctaLink?: string;
  ctaText?: string;
  description?: string;
  height?: string;
  id?: string | number;
  placement?: string;
  title?: string;
  imgHeight?: number;
  imgWidth?: number;
}

@Component({
  selector: 'app-storyblok-spot',
  templateUrl: './storyblok-spot.component.html',
  styleUrls: ['./storyblok-spot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, RouterModule, NgOptimizedImage, RouterContextDirective]
})
export class StoryblokSpotComponent {
  private routingService = inject(RoutingService);


  url: UrlFormatted | undefined;

  get spot(): SpotObj {
    return this._spot;
  }

  @Input()
  set spot(value: SpotObj) {
    if (value?.ctaLink?.startsWith('/sv')) {
      value.ctaLink = '';
    }
    this._spot = value;
    this.url = this.routingService.getUrlFormattedObjectByPath(<string>value?.ctaLink);
  }

  private _spot: SpotObj;

  get style() {
    const style: any = {};

    if (this.spot?.height) {
      style.height = `${this.spot.height}px`;
    }

    return style;
  }

}
